document.addEventListener('DOMContentLoaded', () => {
  const adminBar = document.getElementById('wpadminbar');

  // Adjust header toggle label offset if admin bar exists (for future use or release state)
  const toggleLabel = document.querySelector(
    'label[for="nav-primary-toggle"]'
  ) as HTMLElement | null;
  if (adminBar && toggleLabel) {
    toggleLabel.style.top = `${adminBar.clientHeight}px`;
  }

  const updateTabIndexes = () => {
    const menuLinks = document.querySelectorAll(
      '.nav-menu__link, .nav-submenu__link'
    );

    menuLinks.forEach(link => {
      (link as HTMLElement).setAttribute('tabindex', '0');
    });

    // Mobile submenu toggles are only interactive on mobile;
    // tabindex is managed per breakpoint via CSS display + JS below.
    const submenuToggles = document.querySelectorAll('.nav-submenu__toggle');
    submenuToggles.forEach(btn => {
      (btn as HTMLElement).setAttribute('tabindex', isMobile() ? '0' : '-1');
    });
  };

  const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

  updateTabIndexes();

  // ─── Hamburger / mobile nav overlay ────────────────────────────────────────
  const hamburger = document.getElementById(
    'nav-hamburger'
  ) as HTMLButtonElement | null;
  const navPrimary = document.getElementById(
    'nav-primary'
  ) as HTMLElement | null;

  const openNav = () => {
    if (!hamburger || !navPrimary) return;
    hamburger.setAttribute('aria-expanded', 'true');
    hamburger.setAttribute('aria-label', 'Close navigation menu');
    navPrimary.classList.add('is-open');
    document.body.classList.add('nav-is-open');
    // Move focus into the nav for keyboard users
    const firstLink = navPrimary.querySelector<HTMLElement>('.nav-menu__link');
    firstLink?.focus();
  };

  const closeNav = () => {
    if (!hamburger || !navPrimary) return;
    hamburger.setAttribute('aria-expanded', 'false');
    hamburger.setAttribute('aria-label', 'Open navigation menu');
    navPrimary.classList.remove('is-open');
    document.body.classList.remove('nav-is-open');
  };

  if (hamburger && navPrimary) {
    hamburger.addEventListener('click', () => {
      const isOpen = hamburger.getAttribute('aria-expanded') === 'true';
      if (isOpen) {
        closeNav();
      } else {
        openNav();
      }
    });

    // Close on Escape
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && navPrimary.classList.contains('is-open')) {
        closeNav();
        hamburger.focus();
      }
    });

    // Close when clicking outside the nav (on the backdrop)
    navPrimary.addEventListener('click', e => {
      if (e.target === navPrimary) closeNav();
    });

    // Keep nav closed on resize to desktop width
    window.addEventListener('resize', () => {
      if (!isMobile() && navPrimary.classList.contains('is-open')) {
        closeNav();
      }
      updateTabIndexes();
    });
  }

  // ─── Mobile submenu accordion toggles ──────────────────────────────────────
  const submenuToggles = document.querySelectorAll<HTMLButtonElement>(
    '.nav-submenu__toggle'
  );

  submenuToggles.forEach(toggle => {
    toggle.addEventListener('click', () => {
      // Only operate as accordion on mobile; desktop uses CSS hover
      if (!isMobile()) return;

      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
      const controlsId = toggle.getAttribute('aria-controls');
      const submenu = controlsId ? document.getElementById(controlsId) : null;
      const parentLi = toggle.closest('li');

      toggle.setAttribute('aria-expanded', String(!isExpanded));
      parentLi?.setAttribute('aria-expanded', String(!isExpanded));
      submenu?.classList.toggle('is-open', !isExpanded);
    });
  });
});
